<template>
    <div class="scrolldown">
        <div class="scrolldown__mouse" />
        <div class="scrolldown__arrow">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10" class="icon-svg icon-chevron">
                <path d="M0,8.6l0.9,0.9L8,2.3l7.1,7.2L16,8.6L8,0.5L0,8.6z" />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10" class="icon-svg icon-chevron">
                <path d="M0,8.6l0.9,0.9L8,2.3l7.1,7.2L16,8.6L8,0.5L0,8.6z" />
            </svg>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.scrolldown {
    position: absolute;
    left: 50%;
    bottom: 50px;
    transform: translate(-50%);
    z-index: 3;
    &__mouse {
        width: 24px;
        height: 40px;
        color: black;
        border: 1px solid currentColor;
        border-radius: 999px;
        text-align: center;
        margin: auto;
        &::after {
            content: "";
            position: absolute;
            top: 10px;
            left: 50%;
            -webkit-transform: translateX(-50%);
            -ms-transform: translateX(-50%);
            transform: translateX(-50%);
            display: inline-block;
            width: 4px;
            height: 4px;
            border-radius: 100%;
            background-color: currentColor;
            animation: ScrolldownMouse 2s infinite;
        }
    }
    &__arrow {
        display: flex;
        flex-direction: column;
        margin-top: 8px;
        .icon-svg {
            height: 8px;
            transform: rotate(180deg);
            animation: ScrolldownDoubleArrow 2s infinite;
            animation-delay: 0.2s;
            & + .icon-svg {
                animation-delay: unset;
            }
        }
    }
}
@keyframes ScrolldownMouse {
    0% {
        transform: translateX(-50%) translateY(0);
    }

    80% {
        transform: translateX(-50%) translateY(10px);
    }
}
@keyframes ScrolldownDoubleArrow {
    0% {
        transform: translateY(0) rotate(180deg);
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        transform: translateY(10px) rotate(180deg);
        opacity: 0;
    }
}
</style>